// src/hooks/useBillingShortcuts.ts

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const useBillingShortcuts = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.ctrlKey && e.shiftKey && e.key.toLowerCase() === 'l') {
        console.log("shorctkey cal");

        e.preventDefault();
        document.dispatchEvent(
          new CustomEvent('shortcut-open-last-insert-product')
        );
        return; // important
      }

      // Global Navigation Shortcuts
      if (e.altKey && (e.code === 'KeyP' || e.key.toLowerCase() === 'p')) {
        e.preventDefault();
        navigate('/pos');
        return;
      }
      if (e.altKey && (e.code === 'KeyB' || e.key.toLowerCase() === 'b')) {
        e.preventDefault();
        navigate('/billing');
        return;
      }
      switch (e.code) {
        case 'F1':
          e.preventDefault();
          document.dispatchEvent(new CustomEvent('shortcut-open-product'));
          break;
        case 'F9':
          e.preventDefault();
          document.dispatchEvent(new CustomEvent('shortcut-open-last-insert-product'));
          break;
        case 'F2':
          e.preventDefault();
          document.dispatchEvent(new CustomEvent('shortcut-add-customer'));
          break;
        case 'F3':
          e.preventDefault();
          document.dispatchEvent(new CustomEvent('shortcut-apply-discount'));
          break;
        case 'F12':
          e.preventDefault();
          document.dispatchEvent(new CustomEvent('shortcut-complete-sale'));
          break;
        case 'Escape':
          document.dispatchEvent(new CustomEvent('shortcut-cancel-bill'));
          break;
        default:
          break;
      }
    };

    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, []);
};

export default useBillingShortcuts;